import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { ObjectBrowserWidget } from '@plone/volto/components';

const Sidebar = ({ data, onChangeBlock, block, intl }) => {
  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage
            id="SearchArtworks"
            defaultMessage="Ricerca opere"
          />
        </h2>
      </header>

      <Segment className="form">
        <ObjectBrowserWidget
          id="museum"
          title="Museo"
          description="Seleziona il museo all'interno del quale cercare le opere. Se non viene impostato, verranno ritornate tutte le opere del sito."
          value={data.museum}
          widgetOptions={{
            pattern_options: {
              selectableTypes: ['Museum'],
              maximumSelectionSize: 1,
            },
          }}
          onChange={(name, value) => {
            onChangeBlock(block, {
              ...data,
              [name]: value,
            });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
};

export default injectIntl(Sidebar);
